// Features/TeeInBlue-Events/mod.ts
window.teeinblue ??= {
  cartAjaxTimeout: 99999999,
  cartDelay: 99999999,
  onItemAdded(item) {
    const Event_Product_Added = new CustomEvent("product:added", {
      bubbles: true,
      detail: {
        quantity: item.quantity,
        variant: item.variant_id
      }
    });
    document.dispatchEvent(Event_Product_Added);
    console.debug(`Sent Event_Product_Added`);
    setTimeout(() => {
      const Event_Cart_Updated = new CustomEvent("shopify-event-cart-updated");
      document.dispatchEvent(Event_Cart_Updated);
      console.debug(`Sent Event_Product_Added`);
    }, 1000);
  }
};
